import { isFudaoApp, isWeixinMinProgram, isPC } from './util_04_ua';
import { openAppPage } from './util_15_app';
import { loadScript } from './util_10_lang';
/* eslint-disable */

import { request } from './util_21_request';
import { pcLogin } from './util_25_pc_login';
/* eslint-enable */

/**
 * QQ登录的地址
 * @param {string} succUrl  成功登录的回调地址
 * @memberof module:login
 */

function qqLogin() {
  var succUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
  window.location.href = "".concat('//ui.ptlogin2.qq.com/cgi-bin/login?style=9' + '&appid=716040006&s_url=').concat(encodeURIComponent(succUrl), "&low_login=0&daid=444");
}
/**
 * 微信登录
 * @param {string} succUrl  成功登录的回调地址
 * @memberof module:login
 */


function wxLogin() {
  var succUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
  window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx90cb6dfbfe2d68df&redirect_uri=".concat(encodeURIComponent("".concat(window.location.protocol, "//").concat(window.location.host, "/cgi-bin/uidaccount/k12/login?normal_login=1&ttype=4&account_type=2") + "&buz_id=122051800&appid=wx90cb6dfbfe2d68df&redirect_uri=".concat(encodeURIComponent(succUrl))), "&response_type=code&scope=snsapi_userinfo#wechat_redirect");
}
/**
 * 跳转到登录页
 * @param {string} succUrl 成功登录的回调地址
 * @memberof module:login
 */


function login() {
  var succUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
  var loginPage = "https://gy.fudao.qq.com/login.html?back_url=".concat(encodeURIComponent(succUrl));
  /* istanbul ignore next */
  // 微信小程序

  if (isWeixinMinProgram) {
    wxLogin();
  } else if (isPC()) {
    logout();
    pcLogin.show({
      succ: function succ() {
        if (typeof succUrl === 'string') {
          window.location.href = succUrl;
        } else {
          window.location.reload();
        }
      }
    });
  } else if (isFudaoApp()) {
    openAppPage('login');
  } else {
    window.open(loginPage, '_self');
  }
}
/* istanbul ignore next */
// ptlogin退出登陆， 单清除cookies不进行pt_loginout会出现自动登录问题


function qqLoginOut() {
  var hostDomain = (window.location.hostname.match(/(\.\w+){2}$/) || [".".concat(window.location.hostname)])[0];

  var isLoaded = function isLoaded() {
    return typeof window.pt_logout !== 'undefined';
  };

  return new Promise(function (resolve, reject) {
    loadScript('https://ui.ptlogin2.qq.com/js/ptloginout.js', isLoaded, function () {
      if (window.pt_logout) {
        window.pt_logout.logout();
      }
    });
    resolve();
    setTimeout(function () {
      reject();
    }, 3000);
  });
} // 清除微信、qq、手机号登陆态cookies


var clearAllLoginCookies = function clearAllLoginCookies() {
  return request({
    url: 'https://gy.fudao.qq.com/cgi-proxy/tiny_login/logout',
    method: 'GET',
    params: {}
  });
};
/* istanbul ignore next */

/**
 * 退出所有登录态
 * @memberof module:login
 * @param {function} callback 回调函数
 */


function logout() {
  var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  return Promise.all([qqLoginOut(), clearAllLoginCookies()]).then(function () {
    callback();
  })["catch"](function (err) {
    if (window.BJ_REPORT) {
      window.BJ_REPORT.info("logout err: ".concat(err));
    }

    callback();
  });
}
/**
 * 重新登录
 * @param {string} succUrl  成功登录的回调地址
 * @memberof module:login
 */


function reLogin() {
  var jumpUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
  logout(function () {
    login(jumpUrl);
  });
}
/**
 * 辅导app或qq登录
 * @param {string} succUrl  成功登录的回调地址
 * @memberof module:login
 */


function toLogin() {
  var succUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;

  if (isFudaoApp()) {
    openAppPage('login');
  } else {
    qqLogin(succUrl);
  }
}

export { qqLogin, wxLogin, login, logout, reLogin, toLogin };